/**
 * seamlessPatterns — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {SQUARE, tagline, chips, type ToilePack} from './data'

export const seamlessPatternsPack: ToilePack = {
    slug: 'seamless-patterns',
    category: 'seamless',
    name: 'Seamless patterns',
    tagline: tagline('tiles', 'motifs', 'scales'),
    chips: chips('motifs', 'scales'),
    ratio: SQUARE,
    readings: [
        {key: 'strawberry', label: 'Strawberries', subject: 'ripe strawberries with leaves and small white blossoms'},
        {key: 'deco', label: 'Art-deco fans', subject: 'art-deco fans of stacked arcs with slim rays'},
        {key: 'meadow', label: 'Wildflower meadow', subject: 'poppies, cornflowers, daisies and grass stems'},
    ],
    styles: [
        {key: 'ditsy', label: 'Ditsy', style: 'ditsy small-scale, dense and even', palette: 'flat even color', framing: 'tileable, no border'},
        {key: 'statement', label: 'Statement', style: 'large statement scale, bold and graphic', palette: 'flat even color', framing: 'tileable, generous negative space'},
        {key: 'blockprint', label: 'Block-print', style: 'two-tone block-print, carved-lino edges', palette: 'one ink on unbleached ground', framing: 'tileable, hand-cut texture'},
    ],
    directions: ['lemons instead', 'in navy and cream', 'sparser, more ground showing'],
}
